import React from 'react';
import { Layout as AntLayout, Menu, theme, Button, Space, Dropdown, Tag } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  FormOutlined,
  UnorderedListOutlined,
  LineChartOutlined,
  DownloadOutlined,
  RobotOutlined,
  UserOutlined,
  LogoutOutlined,
  DownOutlined
} from '@ant-design/icons';
import type { MenuProps } from 'antd';

const { Header, Sider, Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
  userEmail?: string | null;
  isAnonymous?: boolean;
  onLogout?: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, userEmail, isAnonymous, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    token: { colorBgContainer }
  } = theme.useToken();

  const menuItems = [
    {
      key: '/',
      icon: <DashboardOutlined />,
      label: '仪表盘'
    },
    {
      key: '/input',
      icon: <FormOutlined />,
      label: '数据录入'
    },
    {
      key: '/list',
      icon: <UnorderedListOutlined />,
      label: '数据列表'
    },
    {
      key: '/charts',
      icon: <LineChartOutlined />,
      label: '图表分析'
    },
    {
      key: '/export',
      icon: <DownloadOutlined />,
      label: '数据导出'
    },
    {
      key: '/ai',
      icon: <RobotOutlined />,
      label: 'AI助手'
    }
  ];

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: onLogout
    }
  ];

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        style={{ background: colorBgContainer }}
      >
        <div style={{ 
          height: 64, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          borderBottom: '1px solid #f0f0f0' 
        }}>
          <h3 style={{ margin: 0 }}>健康监测</h3>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          style={{ borderRight: 0 }}
        />
      </Sider>
      <AntLayout>
        <Header style={{ 
          padding: '0 24px', 
          background: colorBgContainer, 
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <h2 style={{ margin: 0 }}>个人健康数据管理</h2>
          
          <Space>
            {isAnonymous && (
              <Tag color="orange">匿名模式</Tag>
            )}
            {userEmail && (
              <Tag color="blue">{userEmail}</Tag>
            )}
            
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <Button type="text" icon={<UserOutlined />}>
                {userEmail ? userEmail.split('@')[0] : '用户'}
                <DownOutlined style={{ marginLeft: 4, fontSize: 12 }} />
              </Button>
            </Dropdown>
          </Space>
        </Header>
        <Content style={{ margin: 0, minHeight: 280, background: '#f5f5f5' }}>
          <div style={{ background: colorBgContainer, minHeight: '100%' }}>
            {children}
          </div>
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
